import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, CardContent, Tooltip, Typography } from "@mui/material";
import { TGlobusError } from "../../../hooks/useGlobusTransfer";
import { SolutionDetails } from "../GlobusErrorsSolutions";

type GlobusErrorProps = {
    globusError?: TGlobusError;
    solutionDetails: SolutionDetails;
    action?: (param?: any) => void;
}

const handleCopy = async (solutionDetails: SolutionDetails) => {
    try {
        const textToCopy = solutionDetails.steps?.reduce(
            (accumulator, item) => accumulator + `${item.text} \n `, ""
        )
        await navigator.clipboard.writeText(textToCopy ?? "");
    } catch (err) {
        console.error('Failed to copy text: ', err);
    }
};

const GlobusError = (props: GlobusErrorProps) => {
    const { solutionDetails, globusError } = props;

    return solutionDetails?.component ?
        solutionDetails.component({ content: solutionDetails, action: props.action })
        :
        (
            <CardContent>
                <Typography
                    align="center"
                    sx={{ fontWeight: 600, marginBottom: 3 }}
                    variant="h5"
                >
                    {solutionDetails?.title ?? "An error occurred while processing your Globus Transfer request"}
                </Typography>
                <Typography align="center" sx={{ marginBottom: 3 }} variant="h6">
                    {solutionDetails?.subtitle ?? ""}
                </Typography>
                <Box
                    sx={{
                        p: '20px',
                        display: 'flex',
                        width: '100%',
                        alignItems: 'center',
                        marginY: '1rem'
                    }}
                    className="copy-box">
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '95%', gap: 2 }}>
                        {solutionDetails?.steps ? solutionDetails?.steps?.map((step, index) => (
                            <Box sx={{ display: 'flex' }} key={index}>
                                <Typography>{step.text}</Typography>
                                {step.link &&
                                    <a href={step.link} target="_blank" rel="noopener noreferrer">
                                        <OpenInNewIcon />
                                    </a>}
                            </Box>
                        )) : <Typography>{globusError?.message}</Typography>}
                    </Box>
                    <Tooltip sx={{ background: 'green' }} title="Copy to clipboard">
                        <Button onClick={() => handleCopy(solutionDetails)} sx={{ minWidth: '30px' }}>
                            <ContentCopyIcon sx={{ height: '20px', color: '#216C17' }} />
                        </Button>
                    </Tooltip>
                </Box>
            </CardContent>
        )
}

export default GlobusError;